// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__dUjFt","upload":"Small_upload__1KUgY","imageWrap":"Small_imageWrap__12mn1","removeBtn":"Small_removeBtn__3qp7s"};